<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path fill="#EDE7F6" d="M24,7L4,18.89V43h40V18.89L24,7z" />
    <path
      fill="#455A64"
      d="M45,22.048L24,10L3,22.048V17L24,5l0,0l21,12V22.048z"
    />
    <path fill="#F44336" d="M21 18H27V38H21z" />
    <path fill="#F44336" d="M14 25H34V31H14z" />
    <path fill="#B39DDB" d="M4 41H44V43H4z" />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "ClinicIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
